module.exports = __webpack_public_path__ + "07_face.fd670e2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/07_face.png
// module id = 3k6c
// module chunks = 0